import * as React from 'react';
import Head from 'components/Head';

const Privacy = () => {
  return (
    <>
      <Head title="Privacy" description="Privacy" useCurrentUrl />

      <div>
        <div>Full legal privacy coming soon.</div>
        <div>
          Your privacy is our highest priority. None of your details will be public. None of your
          data will be given or sold to 3rd parties.
        </div>
        <div>
          We use analytics tools such as Google Analytics to determine how visitors use the website.
        </div>
      </div>
    </>
  );
};

export default Privacy;
